import React, { type JSX } from 'react'
import styled from '@emotion/styled'
import { Grid, GridCell, GridRow } from '@mobi/component-library/Legacy/Grid'
import { MysteryHeadingStyled } from '@core/Areas/MysteryBet/Components/Common/Common.styles'
import {
  SetSelectedCustomBetCount,
  SetSelectedQuickPickBetCount,
  state$,
} from '@core/Areas/MysteryBet/driver'
import { MysteryToggleButtonStyled } from '@core/Areas/Racing/Components/Mystery/Mystery.styles'
import { useObservableImmutable } from '@core/Utils/hooks'

type NumberOfBetType = 'QuickPick' | 'Custom'

interface NumberOfBetsProps {
  isDisabled: boolean
  type: NumberOfBetType
}

const BET_BUTTON_VALUES = [1, 2, 3, 4, 5]

export const NumberOfBets = ({ isDisabled, type }: NumberOfBetsProps): JSX.Element => {
  const quickPickCount = useObservableImmutable(state$, [
    'selectedQuickPickBetCount',
  ]).selectedQuickPickBetCount
  const customCount = useObservableImmutable(state$, [
    'selectedCustomBetCount',
  ]).selectedCustomBetCount
  const selectedBetCount = type === 'QuickPick' ? quickPickCount : customCount
  const setBetCount =
    type === 'QuickPick' ? SetSelectedQuickPickBetCount : SetSelectedCustomBetCount
  return (
    <>
      <MysteryHeadingStyled>Number of Bets</MysteryHeadingStyled>
      <Grid>
        <GridRow>
          {BET_BUTTON_VALUES.map(x => (
            <GridCell key={x} flexGrow={1}>
              <BetNumberButtonStyled
                num={x}
                disabled={isDisabled}
                isSelected={selectedBetCount === x}
                onClick={() => setBetCount(selectedBetCount === x ? undefined : x)}
                data-tid-number-of-bets={x}
                data-tid-mystery-qp-type={x}
              >
                {x}
              </BetNumberButtonStyled>
            </GridCell>
          ))}
        </GridRow>
      </Grid>
    </>
  )
}

// ======
// Styles
// ======

const BetNumberButtonStyled = styled(MysteryToggleButtonStyled)(
  {
    width: '100%',
    borderRadius: 0,
  },
  ({ num }: { num: number }) => ({
    borderRightWidth: num === 5 ? '1px' : 0,
  })
)
